<template>
  <div id="app">
    <MainMenu />
    <router-view />
  </div>
</template>
<script>
import MainMenu from './components/MainMenu'
export default {
  created(){
    document.title = 'CEMACO'
  },
  components: {
    MainMenu
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
